module.exports = __webpack_public_path__ + "img/icon-confirmation-email.36f43297.svg";